import {TodoCallRequestDTO} from "./dto/TodoCallRequestDTO";
import {TodoCallEventView} from "./view/TodoCallEventView";
import {TodoOpenForRfpView} from "./view/TodoOpenForRfpView";
import {requestService} from "../../services/RequestService";
import {ApiRoutes} from "../../routes/ApiRoutes";

export const TodoModelAPI = {
    /**
     * The open call-todo attached to a lead (owner name + due date), or null when there is none
     * (the server answers 204).
     */
    getOpenTodoForPartnerRfp: async (partnerRfpId: number): Promise<TodoOpenForRfpView | null> => {
        const response = await requestService.get(ApiRoutes.REST_API_URL_TODO_BY_PARTNER_RFP + partnerRfpId, {});
        return response.data ? new TodoOpenForRfpView(response.data) : null;
    },

    /**
     * Fetches active call todos as calendar events.
     */
    getCallEvents: async (request: TodoCallRequestDTO): Promise<TodoCallEventView[]> => {
        const response = await requestService.post(ApiRoutes.REST_API_URL_TODO_CALL_EVENTS, request);
        return (response.data as any[]).map((item) => new TodoCallEventView(item));
    },

    /**
     * Count of the operator's active call todos due today.
     */
    getTodayReminderCount: async (): Promise<number> => {
        const response = await requestService.get(ApiRoutes.REST_API_URL_TODO_CALL_EVENTS_TODAY_COUNT);
        return response.data as number;
    },

    /**
     * Creates an active call follow-up (todo) for a member, optionally tied to a lead. When a comment
     * is given, the server also files an accompanying CRM comment.
     */
    createTodo: async (request: {
        memberId: number;
        partnerRfpId?: number | null;
        dueDate: Date;
        hour?: number | null;
        comment?: string | null;
        // When true, also push this reminder to the operator's Google Workspace calendar (REBO-959).
        addToGoogleCalendar?: boolean;
    }): Promise<void> => {
        await requestService.post(ApiRoutes.REST_API_URL_TODO_CREATE, request);
    }
};